var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountBadgeEntityName, accountBadgePrintedAttachmentKey } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { getAccountBadgeZipFileName } from '../../../../ui/util/getAccountBadgeZipFileName';
import { getBadgeFileName } from '../../../../ui/util/getBadgeFileName';
import { getAttachmentUrl } from '@juvare/platform-sdk-react/ui/utils';
import { ZipWriter } from '@zip.js/zip.js';
export function useDownloadAccountBadgeAttachments() {
    const { t } = useBadgingTranslation();
    const downloadAccountBadgeAttachmentsZip = (attachments) => __awaiter(this, void 0, void 0, function* () {
        const fileNamesCount = {};
        const filesToZip = yield Promise.all(attachments.map((params) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const attachmentUrl = getAttachmentUrl(Object.assign(Object.assign({}, params), { key: accountBadgePrintedAttachmentKey, entity: accountBadgeEntityName, entityId: params.accountBadgeId }));
            let fileName = (_a = params.downloadFileName) !== null && _a !== void 0 ? _a : getBadgeFileName(params.accountDisplayName);
            if (fileNamesCount[fileName]) {
                fileName = fileName.replace('.pdf', `_${fileNamesCount[fileName]}.pdf`);
            }
            fileNamesCount[fileName] = ((_b = fileNamesCount[fileName]) !== null && _b !== void 0 ? _b : 0) + 1;
            const attachmentResponse = yield fetch(attachmentUrl);
            if (!attachmentResponse.ok) {
                throw new Error(t('badges.failedToDownloadAttachment', { fileName }));
            }
            return {
                fileName: fileName,
                blob: yield attachmentResponse.blob(),
            };
        })));
        const zipFileStream = new TransformStream();
        const zipFileBlobPromise = new Response(zipFileStream.readable).blob();
        const zipWriter = new ZipWriter(zipFileStream.writable);
        yield Promise.all(filesToZip.map((_a) => __awaiter(this, [_a], void 0, function* ({ fileName, blob }) {
            yield zipWriter.add(fileName, blob.stream());
        })));
        yield zipWriter.close();
        const zipFileBlob = yield zipFileBlobPromise;
        const url = window.URL.createObjectURL(zipFileBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = getAccountBadgeZipFileName();
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    });
    const downloadAccountBadgeAttachment = (params) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const attachmentUrl = getAttachmentUrl(Object.assign(Object.assign({}, params), { key: accountBadgePrintedAttachmentKey, entity: accountBadgeEntityName, entityId: params.accountBadgeId }));
        const fileName = (_a = params.downloadFileName) !== null && _a !== void 0 ? _a : getBadgeFileName(params.accountDisplayName);
        const attachmentResponse = yield fetch(attachmentUrl);
        if (!attachmentResponse.ok) {
            throw new Error(t('badges.failedToDownloadAttachment', { fileName }));
        }
        const attachmentBlob = yield attachmentResponse.blob();
        const url = window.URL.createObjectURL(attachmentBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    });
    return { downloadAccountBadgeAttachment, downloadAccountBadgeAttachmentsZip };
}
